var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.user.role == 'admin')?_c('ProjectList'):_vm._e(),(_vm.user.role == 'employee')?_c('EmpProjectList'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }